const CONTENT_LIBRARY_URL_FILE_NAME = "cd-content-library.url";

export default CONTENT_LIBRARY_URL_FILE_NAME;
